import React from 'react';
import PropTypes from 'prop-types';

import {
	findTagByName,
	findTagsByName,
	getTagValue,
	getTagIcon,
} from './tag-service';

const PRODUCT_TAG_PREFIX = 'DCU product:';

function getBadges({ tags }) {
	let badges = [];

	let delivery = findTagsByName(tags, 'DCU delivery');
	if (delivery) {
		delivery.forEach((item) => {
			let explode = item.split(':');
			if (explode[1]) {
				badges.push(explode[1].toLowerCase());
			}
		});
	}

	if (findTagByName(tags, 'DCU certification')) {
		badges.push('certification');
	}

	let dcu_badges = findTagsByName(tags, 'DCU badge');
	if (dcu_badges) {
		dcu_badges.forEach((item) => {
			let explode = item.split(':');
			if (explode[1]) {
				badges.push(explode[1].toLowerCase());
			}
		});
	}

	return badges;
}

export const ContentExchangeCardUniversity = ({ id, url, title, date, tags }) => {
	let badges = getBadges({ date, tags });
	let productTags = tags.filter(t => t.indexOf(PRODUCT_TAG_PREFIX) === 0);
	let directoryTheme = '/wp-content/themes/dc';

	if (url.indexOf('duck_creek_university') != -1) {
		url = url.replace('/content-exchange/duck_creek_university/course_catalog/', "/duck-creek-university/course-catalog/");
	}

	return (
		<a key={id} href={url} className="card content-exchange-page-card">
			<div className="card-header">
				{badges.map(b => (
					<span className="badge" data-tooltip={b}>
						<img
							className="badge-image"
							src={`${directoryTheme}/resources/images/content-exchange-icons/${b}.svg`}
							alt={b}
						/>
					</span>
				))}
			</div>
			<div className="content-type">
				{getTagValue(tags, 'DCU duration')}
			</div>
			<div className="title">{title}</div>
			<div className="course-number">{getTagValue(tags, 'DCU courseNumber')}</div>
			<div className="call-to-action">Learn More</div>
			<ul className="product-line">
				{productTags.map(tag => (
					<li
						className="product-line-item"
						data-tooltip={tag.replace(PRODUCT_TAG_PREFIX, '')}
					>
						<img
							className="product-line-icon"
							src={getTagIcon(tag)}
							alt={tag.replace(PRODUCT_TAG_PREFIX, '')}
						/>
					</li>
				))}
			</ul>
		</a>
	);
};

ContentExchangeCardUniversity.propTypes = {
	id: PropTypes.string,
	tags: PropTypes.array,
	url: PropTypes.string,
	title: PropTypes.string,
	date: PropTypes.string
};
